import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {
  BaseResponse, EquipmentTypeResponse, EquipmentsResponse, EquipmentUsersResponse, EquipmentsRequest, EquipmentUsersRequest
} from '../core/core.component';
import {Http, Headers} from '@angular/http';
import { environment } from 'environments/environment';
import {AppConstants} from '../core/app.constants';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class EquipmentService {

  private pattern = 'yyyy-MM-dd';

  constructor(private http: Http, private datePipe: DatePipe) {}

  getEquipmentTypes(srmToken): Observable<EquipmentTypeResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentType';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }

  insertEquipmentType(srmToken, desc: string, flagMac: boolean): Observable<EquipmentTypeResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentType';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      desc: desc,
      flagMac: flagMac
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  updateEquipmentType(srmToken, id: number, desc: string, flagMac: boolean): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentType/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      desc: desc,
      flagMac: flagMac
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteEquipmentType(srmToken, id: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentType/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
  }

  getEquipments(srmToken, request?: EquipmentsRequest): Observable<EquipmentsResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipment';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.post(url, request, {headers: headers}).map((responseData) => responseData.json());
  }

  insertEquipment(srmToken, desc: string, idTipo: number, serialNumber?: string, dataAcquisto?: Date, codCespite?: string, dataAlienazione?: Date, macAddress?: string, note?: string): Observable<EquipmentsResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipment';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      desc: desc,
      idTipo: idTipo,
      serialNumber: serialNumber,
      dataAcquisto: this.datePipe.transform(dataAcquisto, this.pattern),
      codCespite: codCespite,
      dataAlienazione: this.datePipe.transform(dataAlienazione, this.pattern),
      macAddress: macAddress,
      note: note
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  updateEquipment(srmToken, id: number, desc: string, idTipo: number, serialNumber?: string, dataAcquisto?: Date, codCespite?: string, dataAlienazione?: Date, macAddress?: string, note?: string): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipment/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      id: id,
      desc: desc,
      idTipo: idTipo,
      serialNumber: serialNumber,
      dataAcquisto: this.datePipe.transform(dataAcquisto, this.pattern),
      codCespite: codCespite,
      dataAlienazione: this.datePipe.transform(dataAlienazione, this.pattern),
      macAddress: macAddress,
      note: note
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteEquipment(srmToken, id: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipment/' + id;
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
  }

  getEquipmentUsers(srmToken, request?: EquipmentUsersRequest): Observable<EquipmentUsersResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.post(url, request, {headers: headers}).map((responseData) => responseData.json());
  }

  upsertEquipmentUser(srmToken, insert: boolean, id: number, idUser: number, idEquip: number, dataInizioAssegnaz: Date, dataFineAssegnaz?: Date): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      insert: insert,
      id: id,
      idUser: idUser,
      idEquip: idEquip,
      dataInizioAssegnaz: this.datePipe.transform(dataInizioAssegnaz, this.pattern),
      dataFineAssegnaz: this.datePipe.transform(dataFineAssegnaz, this.pattern)
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteEquipmentUser(srmToken, id: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/equipment/equipmentUser';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const body = {
      id: id
    };
    return this.http.delete(url, {headers: headers, body: body}).map((responseData) => responseData.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/service/equipment.service.ts